<template>
  <div class="bb-filter-popup">
    <BBSelectImage
      :isOpen="isOpen"
      :options="options"
      :label="column.label"
      :isAllFilter="column.isAllFilter"
      :isActiveAll="column.isActiveAll"
      :value="value"
      :isCrm="true"
      :isSelectUserFilter="true"
      @change="onChange"
      @onAllFilter="onAllFilter"
    />
  </div>
</template>

<script>

import BBSelectImage from '@/components/Main/Inputs/BBSelectImage'

export default {
  name: 'BBPFilterPopup',
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    filterOpen: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    value: null
  }),
  components: {
    BBSelectImage
  },
  computed: {
    options () {
      const { options = [] } = this.column
      return options
    }
  },
  methods: {
    onChange (value) {
      if (this.value && this.value._id === value._id) {
        this.value = {}
        this.$emit('onChangeFilter', this.column, {})
      } else {
        this.value = value
        this.$emit('onChangeFilter', this.column, value)
      }
      this.column.isActiveAll = false
    },
    setDefaultValue () {
      const currentItem = this.options.find((el) => el.isActive)
      this.value = currentItem
    },
    onAllFilter () {
      const { isActiveAll = false } = this.column
      this.column.isActiveAll = !isActiveAll
      this.value = {}
      this.$emit('onChangeFilter', this.column, {}, true)
    }
  },
  watch: {
    options () {
      this.setDefaultValue()
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>

<style lang="scss" scoped>

.bb-filter-popup {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBFilterPopup/BBFilterPopup.vue